module.exports = __webpack_public_path__ + "static/media/renaatus.22b47175.png";